module.exports = __webpack_public_path__ + "static/shco-e7c1a57b9fac0ae2f291f28cc3ad4db1.jpg";